var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.selectedInitiative.footer_text))]),_c('div',{staticClass:"time-container"},[_c('span',[_vm._v(_vm._s(new Date().getHours() + ":" + new Date().getMinutes()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }